/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Meta_DescriptionInputs */

const id_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi dan kelola notifikasi push untuk pembaruan Epic Games Store, rilis game, dan banyak lagi.`)
};

const ms_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi dan urus pemberitahuan push untuk kemas kini Epic Games Store, keluaran permainan, dan banyak lagi.`)
};

const da_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurér og administrér push-notifikationer for Epic Games Store opdateringer, spiludgivelser og mere.`)
};

const de_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren und verwalten Sie Push-Benachrichtigungen für Epic Games Store-Updates, Spielveröffentlichungen und mehr.`)
};

const en_us2_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure and manage push notifications for Epic Games Store updates, game releases, and more.`)
};

const es_es2_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura y administra notificaciones push para actualizaciones de la Epic Games Store, lanzamientos de juegos y más.`)
};

const es_mx2_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura y administra notificaciones push para actualizaciones de la Epic Games Store, lanzamientos de juegos y más.`)
};

const fil_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-configure at pamahalaan ang mga push notification para sa mga update ng Epic Games Store, paglabas ng laro, at marami pa.`)
};

const fr_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez et gérez les notifications push pour les mises à jour de l'Epic Games Store, les sorties de jeux et plus encore.`)
};

const it_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura e gestisci le notifiche push per gli aggiornamenti dell'Epic Games Store, le uscite di giochi e altro ancora.`)
};

const hu_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push értesítések konfigurálása és kezelése az Epic Games Store frissítéseihez, játékmegjelenésekhez és egyéb eseményekhez.`)
};

const nl_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushmeldingen configureren en beheren voor Epic Games Store-updates, gamereleases en meer.`)
};

const no_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurer og administrer push-varsler for Epic Games Store-oppdateringer, spillutgivelser og mer.`)
};

const pl_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguruj i zarządzaj powiadomieniami push dotyczącymi aktualizacji Epic Games Store, premier gier i nie tylko.`)
};

const pt_br2_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e gerencie notificações push para atualizações de Epic Games Store, lançamentos de jogos e muito mais.`)
};

const pt_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e gerencie notificações push para atualizações da Epic Games Store, lançamentos de jogos e muito mais.`)
};

const ro_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurează și gestionează notificările push pentru actualizări Epic Games Store, lansări de jocuri și multe altele.`)
};

const fi_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Määritä ja hallitse push-ilmoituksia Epic Games Store -päivityksille, pelijulkaisuille ja muulle.`)
};

const sv_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurera och hantera push-notiser för Epic Games Store-uppdateringar, spelrelease och mer.`)
};

const vi_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình và quản lý thông báo đẩy cho các cập nhật Epic Games Store, bản phát hành game và hơn thế nữa.`)
};

const tr_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store güncellemeleri, oyun çıkışları ve daha fazlası için push bildirimlerini yapılandırın ve yönetin.`)
};

const cs_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakonfigurujte a spravujte push oznámení pro aktualizace Epic Games Store, vydání her a další.`)
};

const bg_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфигурирайте и управлявайте push известия за актуализации на Epic Games Store, издания на игри и други.`)
};

const ru_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте push-уведомления для обновлений Epic Games Store, релизов игр и многого другого.`)
};

const uk_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налаштовуйте та керуйте push-сповіщеннями для оновлень Epic Games Store, релізів ігор тощо.`)
};

const ar_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكوين وإدارة الإشعارات الفورية لتحديثات Epic Games Store وإصدارات الألعاب والمزيد.`)
};

const hi_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store अपडेट, गेम रिलीज़ के लिए पुश सूचनाएँ कॉन्फ़िगर करें।`)
};

const th_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำหนดค่าและจัดการการแจ้งเตือนแบบพุชสำหรับการอัปเดต Epic Games Store การวางจำหน่ายเกม และอื่น ๆ`)
};

const ja_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の更新、ゲームリリースなどのプッシュ通知を設定・管理。`)
};

const zh_cn2_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置并管理Epic游戏商城的推送通知，包括游戏发布、更新等。`)
};

const zh_hant1_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定並管理Epic遊戲商城的推播通知，包括遊戲發布、更新等。`)
};

const ko_notifications_meta_description = /** @type {(inputs: Notifications_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 업데이트, 게임 출시 등에 대한 푸시 알림을 구성하고 관리합니다.`)
};

/**
* | output |
* | --- |
* | "Configure and manage push notifications for Epic Games Store updates, game releases, and more." |
*
* @param {Notifications_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_meta_description = /** @type {((inputs?: Notifications_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_meta_description(inputs)
	if (locale === "ms") return ms_notifications_meta_description(inputs)
	if (locale === "da") return da_notifications_meta_description(inputs)
	if (locale === "de") return de_notifications_meta_description(inputs)
	if (locale === "en-US") return en_us2_notifications_meta_description(inputs)
	if (locale === "es-ES") return es_es2_notifications_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_notifications_meta_description(inputs)
	if (locale === "fil") return fil_notifications_meta_description(inputs)
	if (locale === "fr") return fr_notifications_meta_description(inputs)
	if (locale === "it") return it_notifications_meta_description(inputs)
	if (locale === "hu") return hu_notifications_meta_description(inputs)
	if (locale === "nl") return nl_notifications_meta_description(inputs)
	if (locale === "no") return no_notifications_meta_description(inputs)
	if (locale === "pl") return pl_notifications_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_meta_description(inputs)
	if (locale === "pt") return pt_notifications_meta_description(inputs)
	if (locale === "ro") return ro_notifications_meta_description(inputs)
	if (locale === "fi") return fi_notifications_meta_description(inputs)
	if (locale === "sv") return sv_notifications_meta_description(inputs)
	if (locale === "vi") return vi_notifications_meta_description(inputs)
	if (locale === "tr") return tr_notifications_meta_description(inputs)
	if (locale === "cs") return cs_notifications_meta_description(inputs)
	if (locale === "bg") return bg_notifications_meta_description(inputs)
	if (locale === "ru") return ru_notifications_meta_description(inputs)
	if (locale === "uk") return uk_notifications_meta_description(inputs)
	if (locale === "ar") return ar_notifications_meta_description(inputs)
	if (locale === "hi") return hi_notifications_meta_description(inputs)
	if (locale === "th") return th_notifications_meta_description(inputs)
	if (locale === "ja") return ja_notifications_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_meta_description(inputs)
	return ko_notifications_meta_description(inputs)
});
export { notifications_meta_description as "notifications.meta.description" }